import React, {
  useEffect,
  useState,
} from "react";
import { NavLink } from "react-router-dom";
import "../Styles/Home.css";

import {
  Wallet,
  Landmark,
  BadgeDollarSign,
  ChevronRight,
  Activity,
  ShieldCheck,
  ArrowUpRight,
  PiggyBank,
} from "lucide-react";

import rcsLogo from "../assets/rcslogo.png";

const Home = () => {

  const [quote, setQuote] =
    useState("");

  const affirmations = [

    "Success is not for the chosen few — it’s for the few who choose it daily.",

    "Discipline creates freedom. Keep building your empire.",

    "Every small step you take today strengthens the business you’ll have tomorrow.",

    "Progress, not perfection. Each improvement counts.",

    "Your vision is valid. Keep going, one day at a time.",

    "The key to growth is consistency — and you’re doing it.",

    "Stay focused. Your effort today funds your freedom tomorrow.",

    "Excellence is the gradual result of always striving to do better.",
  ];

  useEffect(() => {

    const randomIndex =
      Math.floor(
        Math.random() *
        affirmations.length
      );

    setQuote(
      affirmations[randomIndex]
    );

  }, []);

  return (

    <div className="modern-home-page">

      {/* ================================= */}
      {/* BACKGROUND GLOWS */}
      {/* ================================= */}

      <div className="home-glow glow-1" />
      <div className="home-glow glow-2" />

      {/* ================================= */}
      {/* HERO SECTION */}
      {/* ================================= */}

      <div className="home-hero-card">

        {/* LEFT */}

        <div className="home-hero-left">

          <div className="home-badge">

            <ShieldCheck size={14} />

            Admin Operations

          </div>

          <h1 className="modern-home-title">

            RCS Admin
            <br />
            Console

          </h1>

          <p className="modern-home-subtitle">

            Unified financial oversight,
            account management,
            transaction control,
            reporting and operational
            monitoring for the RCS ecosystem.

          </p>

          <div className="home-hero-actions">

            <button className="hero-primary-btn">

              Open Dashboard

              <ChevronRight size={18} />

            </button>

            <button className="hero-secondary-btn">

              View Reports

            </button>

          </div>

          <div className="modern-quote-card">

            <Activity size={18} />

            <span>
              {quote}
            </span>

          </div>

        </div>

        {/* RIGHT */}

<div className="home-orbit-wrapper">

  {/* CENTER LOGO */}

  <div className="home-orbit-center-logo">

    <img
      src={rcsLogo}
      alt="RCS"
      className="home-orbit-logo"
    />

  </div>

  {/* ORBIT RING */}

  <div className="home-orbit-ring" />

  {/* ITEMS */}

  <NavLink
    to="/accounts"
    className="home-orbit-card home-orbit-1"
  >

    <Wallet size={18} />

    <div>
      <h4>Accounts</h4>
      <span>
        Financial control
      </span>
    </div>

  </NavLink>

  <NavLink
    to="/cheque-tracker"
    className="home-orbit-card home-orbit-2"
  >

    <ShieldCheck size={18} />

    <div>
      <h4>Cheque Tracker</h4>
      <span>
        Secure cheque logs
      </span>
    </div>

  </NavLink>

  <NavLink
    to="/mmg"
    className="home-orbit-card home-orbit-3"
  >

    <Landmark size={18} />

    <div>
      <h4>MMG</h4>
      <span>
        Transaction oversight
      </span>
    </div>

  </NavLink>

  <NavLink
    to="/loan"
    className="home-orbit-card home-orbit-4"
  >

    <PiggyBank size={18} />

    <div>
      <h4>Loans</h4>
      <span>
        Portfolio tracking
      </span>
    </div>

  </NavLink>

  <NavLink
    to="/lottery"
    className="home-orbit-card home-orbit-5"
  >

    <BadgeDollarSign size={18} />

    <div>
      <h4>Lottery</h4>
      <span>
        Lottery management
      </span>
    </div>

  </NavLink>

  <NavLink
    to="/phone-cards"
    className="home-orbit-card home-orbit-6"
  >

    <Activity size={18} />

    <div>
      <h4>Phone Cards</h4>
      <span>
        Card monitoring
      </span>
    </div>

  </NavLink>

</div>

      </div>

      {/* ================================= */}
      {/* QUICK STATS */}
      {/* ================================= */}

      <div className="home-stats-grid">

        <div className="home-stat-card">

          <div className="stat-icon">

            <Wallet size={20} />

          </div>

          <div>

            <h3>
              Accounts
            </h3>

            <p>
              Manage balances,
              ledgers and cash flow
            </p>

          </div>

          <ArrowUpRight
            size={18}
            className="stat-arrow"
          />

        </div>

        <div className="home-stat-card">

          <div className="stat-icon">

            <BadgeDollarSign size={20} />

          </div>

          <div>

            <h3>
              Loan Control
            </h3>

            <p>
              Track repayments,
              ROI and balances
            </p>

          </div>

          <ArrowUpRight
            size={18}
            className="stat-arrow"
          />

        </div>

        <div className="home-stat-card">

          <div className="stat-icon">

            <Landmark size={20} />

          </div>

          <div>

            <h3>
              MMG Monitoring
            </h3>

            <p>
              Live financial
              transaction oversight
            </p>

          </div>

          <ArrowUpRight
            size={18}
            className="stat-arrow"
          />

        </div>

      </div>

      {/* ================================= */}
      {/* FOOTER NOTE */}
      {/* ================================= */}

      <div className="modern-home-footer">

        <p>

          All information contained
          within this application
          is intended for authorized
          RCS personnel only.
          Unauthorized access or
          misuse may result in
          disciplinary and legal action.

        </p>

      </div>

    </div>
  );
};

export default Home;